import React, { Component } from 'react';
import { findIndex, uniqBy } from 'lodash/array';
import { orderBy } from 'lodash/collection';
import { reject } from 'lodash/collection';

import common from '../../../../../common/common';
import Select from '../../../../../common/data-entry/Select';
import ModalBoxes from '../../../../../common/feedback/ModalBoxes/ModalBoxes';
import Button from '../../../../../common/general/Button';
import ButtonGroup from '../../../../../common/general/ButtonGroup';
import NotificationManager from '../../../../../common/notifications/NotificationManager';
import { DUPLICATE_CUSTOM_OPTION_VALUES_NOT_ALLOWED } from '../../../../../constants/notificationMessages';
import { onRequestDefaultError } from '../../../../../services/handlers';

import { getContollTermListDependsPage } from './itemGroupSetupService';

import 'react-super-select/lib/react-super-select.css';
import './EditFormAnswerFields.scss';

class EditFormAnswerFields extends Component {
  constructor(props) {
    super(props);
    this.state = {
      controlledTermList: [],
      controlledTermListOptions: [],
      finalOptions: [],
      custOptName: '',
      controlledTermListOptionsDefault: [],
      selectedControlTermListItem: '',
      editedOptions: [],
      editedFoundStandard: []
    };
    this.currentDragIndex = null;
  }

  componentDidMount() {
    try {
      if (this.props.itemDefinationData.hasOwnProperty('customOptionList')) {
        this.setState({
          finalOptions:
            this.props.itemDefinationData.customOptionList &&
            orderBy(this.props.itemDefinationData.customOptionList, 'sequence', 'asc'),
          editedFoundStandard: this.props.itemDefinationData.editedFoundStandard,
          editedOptions: this.props.itemDefinationData.customOptionList.concat(
            this.props.itemDefinationData.editedFoundStandard
          )
        });
      }

      let tempEditOptionList = [];
      this.props.itemDefinationData.codeDefinationList.forEach((item, index) => {
        if (item.decode) {
          const obj = {
            index: index + 1,
            value: item.decode,
            sequence: item.sequence ? item.sequence : index + 1
          };
          tempEditOptionList.push(obj);
        }
      });
      tempEditOptionList = orderBy(tempEditOptionList, 'sequence', 'asc');
      this.setState({
        editedOptions: tempEditOptionList,
        finalOptions: this.props.itemDefinationData.isExtensible === 2 ? tempEditOptionList : []
      });
      getContollTermListDependsPage.call(this).then(({ data }) => {
        const maped = data.map(item => {
          return { id: item.uniqueIdentifier, name: item.ctName, ctMenu: item.ctMenu };
        });
        this.setState({ controlledTermList: maped }, () => {
          if (this.props.itemDefinationData && this.props.itemDefinationData.isExtensible === 3) {
            this.onChangeTermList(this.getCtrlTermListDefaultSelection());
          }
        });
      }, onRequestDefaultError);
    } catch (e) {
      console.log(e);
    }
  }

  addItem = () => {
    this.props.onSave && this.props.onSave(this.state);
  };

  onClose = () => {
    this.props.modalBox.close();
  };

  onOptionsDragStart = (e, index) => {
    e.dataTransfer.setData('text', 'dragRow');
    // e.dataTransfer.effectAllowed = 'move';
    if (index != null) {
      e.dataTransfer.effectAllowed = 'move';
    }
    this.currentDragIndex = index;
  };

  onOptionsDragOver = (e, index) => {
    if (e.nativeEvent && e.nativeEvent.dataTransfer.effectAllowed === 'move') {
    }
    e.preventDefault();
  };

  onOptionsDrop = (e, index) => {
    const refEle = this.state.finalOptions[this.currentDragIndex];
    const prevOptState = this.state.finalOptions;
    prevOptState.splice(this.currentDragIndex, 1);
    prevOptState.splice(index, 0, refEle);
    prevOptState.forEach((itemOpt, index) => {
      itemOpt.sequence = index + 1;
    });
    this.setState({ finalOptions: prevOptState });
    this.refs.finalOptContainer.children[index].classList.remove('over');
    e.preventDefault();
  };

  onOptionsDragEnter = (e, index) => {
    if (e.preventDefault) {
      e.preventDefault();
    }
    this.refs.finalOptContainer.children[index].classList.add('over');
  };

  onOptionsDragLeave = (e, index) => {
    this.refs.finalOptContainer.children[index].classList.remove('over');
  };

  removeFinalOptions = (e, index) => {
    const option = this.state.finalOptions[index];

    this.props.checkAndPromptLinkedFieldsBeforeDelete(option.value).then(
      () => {
        this.setState(function({ controlledTermListOptionsDefault, finalOptions }) {
          return {
            finalOptions: reject(finalOptions, (o, i) => i === index).map((o, i) => ({ ...o, sequence: i + 1 })),
            controlledTermListOptionsDefault: reject(controlledTermListOptionsDefault, [
              'uniqueIdentifier',
              option.uniqueIdentifier
            ])
          };
        });
      },
      () => {}
    );
  };

  // adding new customoption
  addCustomOption = e => {
    if (this.state.custOptName && this.state.custOptName.trim()) {
      const prevSt = this.state.finalOptions;
      const duplicateCustOptName = prevSt.filter(item => {
        return item.value && this.state.custOptName && item.value.trim() === this.state.custOptName.trim();
      });
      if (duplicateCustOptName && duplicateCustOptName.length > 0) {
        NotificationManager.error(DUPLICATE_CUSTOM_OPTION_VALUES_NOT_ALLOWED);
      } else {
        const opt = {
          index: prevSt.length + 1,
          value: this.state.custOptName,
          type: 'custom',
          sequence: prevSt.length + 1
        };
        prevSt.push(opt);
        this.setState({ finalOptions: prevSt, custOptName: '' });
      }
    } else {
      NotificationManager.error('Please enter the option');
    }
  };

  onChangeTermList = option => {
    try {
      if (option) {
        let prevFinalOpt = this.state.editedOptions;
        this.state.controlledTermList.forEach((item, index) => {
          if (item.name === option.name) {
            item.ctMenu.forEach(itx => {
              itx.id = itx.uniqueIdentifier;
              itx.name = itx.ctValue;
              itx.group = 'ctl';
            });

            if (this.props.itemDefinationData.ctListName === option.name) {
              prevFinalOpt.forEach((it, ix) => {
                const idx = findIndex(item.ctMenu, o => {
                  if (it.value === o.ctValue) {
                    it.uniqueIdentifier = o.uniqueIdentifier;
                    return it;
                  }
                });
                if (idx === -1) {
                  prevFinalOpt[ix].type = 'custom';
                }
              });
            }

            if (this.props.itemDefinationData.hasOwnProperty('customOptionList')) {
              let tmpEditSele = [];
              this.state.editedFoundStandard.forEach((data, index) => {
                const foundRecord = item.ctMenu.filter(f => {
                  return f.name === data.value;
                });
                tmpEditSele = tmpEditSele.concat(foundRecord);
              });

              prevFinalOpt = prevFinalOpt.concat(this.props.itemDefinationData.customOptionList);
              prevFinalOpt = uniqBy(prevFinalOpt, 'value');

              this.setState({
                finalOptions: this.props.itemDefinationData.ctListName !== option.name ? [] : prevFinalOpt,
                controlledTermListOptions: item.ctMenu,
                controlledTermListOptionsDefault:
                  this.props.itemDefinationData.ctListName === option.name
                    ? JSON.parse(JSON.stringify(tmpEditSele))
                    : item.ctMenu,
                selectedControlTermListItem: option.name
              });
            } else {
              // map the ct-menus
              const tmpSelection = [];
              const optionVal = JSON.parse(JSON.stringify(item.ctMenu));
              optionVal &&
                optionVal.forEach((opt, opix) => {
                  const idx = findIndex(prevFinalOpt, o => {
                    return o.uniqueIdentifier === opt.uniqueIdentifier;
                  });
                  if (idx > -1 || this.props.itemDefinationData.ctListName !== option.name) {
                    tmpSelection.push(opt);
                  }
                });
              this.setState({
                finalOptions: this.props.itemDefinationData.ctListName !== option.name ? [] : prevFinalOpt,
                controlledTermListOptions: item.ctMenu,
                controlledTermListOptionsDefault: this.props.fromEdit
                  ? JSON.parse(JSON.stringify(tmpSelection))
                  : optionVal, // prevFinalOpt
                selectedControlTermListItem: option.name
              });
            }
          }
        });
      }
    } catch (e) {}
  };

  controlledTermListOptionsChange = option => {
    const prevSt = this.state.finalOptions;
    const prevDefSel = this.state.controlledTermListOptionsDefault;
    if (option) {
      // filter the non custom element
      const nonCustomEle = prevSt.filter(f => {
        return f.type !== 'custom';
      });
      if (nonCustomEle.length) {
        const removedElement = [];
        // check for elements which are not in list
        nonCustomEle.forEach((exsEle, exsIdx) => {
          const foundResultOpt = option.filter(o => {
            return o.uniqueIdentifier === exsEle.uniqueIdentifier;
          });
          if (foundResultOpt.length === 0) {
            removedElement.push(exsEle);
          }
        });
        // remove the element form prev state
        if (removedElement.length) {
          removedElement.forEach(rEl => {
            const idx = findIndex(prevSt, x => {
              return x.uniqueIdentifier === rEl.uniqueIdentifier;
            });
            if (idx > -1) {
              prevSt.splice(idx, 1);
            }
          });
          // reordering the elements
          prevSt.forEach((reordeItem, reIDx) => {
            reordeItem.sequence = reIDx + 1;
          });
        }

        if (this.props.pageName !== 'Item Group Template Setup') {
          // adding new element if new option selected
          option.forEach((nopt, nIx) => {
            const newFound = nonCustomEle.filter(n => {
              return n.uniqueIdentifier === nopt.uniqueIdentifier;
            });
            if (newFound.length === 0) {
              const finalopt = {
                index: prevSt.length + 1,
                value: nopt.ctValue,
                uniqueIdentifier: nopt.uniqueIdentifier,
                sequence: prevSt.length + 1
              };
              prevSt.push(finalopt);
            }
          });
        }
        const prevDefSelected =
          prevDefSel?.filter(item => prevSt?.filter(pr => pr.uniqueIdentifier === item.id).length > 0) || prevDefSel;
        this.setState({
          finalOptions: prevSt,
          custOptName: '',
          controlledTermListOptionsDefault: JSON.parse(JSON.stringify(prevDefSelected))
        });
      } else {
        const tmpSel = [];
        option.forEach((opt, index) => {
          const finalopt = {
            index: index + 1,
            value: opt.ctValue,
            uniqueIdentifier: opt.uniqueIdentifier,
            sequence: index + 1
          };

          tmpSel.push(finalopt);
        });
        if (this.props.itemDefinationData?.ctListName !== this.state.selectedControlTermListItem) {
          this.setState({
            finalOptions: tmpSel,
            custOptName: '',
            controlledTermListOptionsDefault: JSON.parse(JSON.stringify(prevDefSel))
          });
        } else {
          const prevDefSelSelected =
            tmpSel?.filter(item => prevSt?.filter(pr => pr.uniqueIdentifier === item.id).length > 0) || tmpSel;
          this.setState({
            finalOptions: prevDefSelSelected,
            custOptName: '',
            controlledTermListOptionsDefault: JSON.parse(JSON.stringify(prevDefSelSelected))
          });
        }
      }
      // end of code
    } else {
      const foundCustom = prevSt.filter(k => {
        return k.type === 'custom';
      });
      this.setState({
        finalOptions: foundCustom,
        custOptName: '',
        controlledTermListOptionsDefault: []
      });
    }
  };

  customOptionTemplateFunction = (item, search, searchRegex) => {
    return <span title={item.name}>{item.name}</span>;
  };

  getCommaOnAfterItem = (length, itemIndex) => {
    if (length > 1) {
      if (length - 1 === itemIndex) {
        return '';
      }
      return ',';
    }
    return '';
  };

  customSelectedValueTemplateFunction = selectedItmes => {
    return (
      <div className="selected-dropdown-items">
        {selectedItmes.map((item, index) => {
          return (
            <span key={common.getRandomNumber()}>
              {item.name}
              {this.getCommaOnAfterItem(selectedItmes.length, index)}
            </span>
          );
        })}
      </div>
    );
  };

  // get the initial selection
  getCtrlTermListDefaultSelection = () => {
    if (this.props.itemDefinationData.ctListName && this.state.controlledTermList) {
      const foundRes = this.state.controlledTermList.filter(f => {
        return f.name === this.props.itemDefinationData.ctListName;
      });
      if (foundRes.length) {
        return foundRes[0];
      }
      return {
        id: 9999,
        name: this.props.itemDefinationData.ctListName
      };
    }
    return null;
  };

  render({ props, state } = this) {
    return (
      <>
        <ModalBoxes.Header>
          {props.itemDefinationData.isExtensible === 1 && 'Edit Controlled Term List'}
          {props.itemDefinationData.isExtensible === 2 && 'Edit Custom Options List'}
          {props.itemDefinationData.isExtensible === 3 && 'Select Patient Statuses'}
        </ModalBoxes.Header>
        <ModalBoxes.Body>
          {props.itemDefinationData.isExtensible === 1 && (
            <div className="col-12 form-row p-0 m-0 mt-2">
              <div className="form-group col-md-4 col-half-offset">
                <label htmlFor="study" className="fw500">
                  Controlled Term List
                </label>
              </div>
              <div className="form-group col-md-6 col-half-offset">
                <Select
                  legacyLook
                  placeholder="Select"
                  clearSearchOnSelection
                  dataSource={this.state.controlledTermList || []}
                  onChange={option => this.onChangeTermList(option)}
                  clearable={false}
                  deselectOnSelectedOptionClick
                  searchable
                  closeOnSelectedOptionClick={false}
                  value={this.getCtrlTermListDefaultSelection()}
                />
              </div>
            </div>
          )}
          {props.itemDefinationData.isExtensible === 1 && <hr className="hrdivider m-0" />}
          {(props.itemDefinationData.isExtensible === 1 || props.itemDefinationData.isExtensible === 3) && (
            <div className="col-12 form-row p-0 m-0 mt-2">
              <div className="form-group col-md-4 col-half-offset">
                <label htmlFor="study" className="fw500">
                  Controlled Term Options List
                </label>
              </div>
              <div className="form-group col-md-6 col-half-offset">
                <Select
                  placeholder="Select"
                  clearSearchOnSelection
                  dataSource={this.state.controlledTermListOptions || []}
                  onChange={option => this.controlledTermListOptionsChange(option)}
                  clearable={false}
                  deselectOnSelectedOptionClick
                  searchable
                  multiple
                  keepOpenOnSelection
                  closeOnSelectedOptionClick={false}
                  customOptionTemplateFunction={this.customOptionTemplateFunction}
                  legacyLook
                  customSelectedValueTemplateFunction={this.customSelectedValueTemplateFunction}
                  value={
                    this.state.controlledTermListOptionsDefault
                      ? JSON.parse(JSON.stringify(this.state.controlledTermListOptionsDefault)) || []
                      : null
                  }
                />
              </div>
            </div>
          )}
          {props.itemDefinationData.isExtensible !== 3 && (
            <div className="col-12 form-row p-0 m-0 mt-2 mb-2">
              <div className="form-group col-md-4 col-half-offset">
                <label htmlFor="study" className="fw500">
                  {' '}
                  Custom Options List
                </label>
              </div>
              <div className="form-group col-md-6 col-half-offset">
                <input
                  type="text"
                  onChange={e => {
                    this.setState({ custOptName: e.target.value });
                  }}
                  value={this.state.custOptName}
                  className="form-control"
                />
              </div>
              <div className="col-md-1 p-0">
                <span
                  onClick={e => {
                    this.addCustomOption(e);
                  }}
                >
                  <i className="material-icons editicn custAdd pt-1" title="Add custom option to Final Options List">
                    control_point
                  </i>
                </span>
              </div>
            </div>
          )}
          <hr className="hrdivider m-0" />
          <div className="col-12 form-row p-0 m-0 mt-2">
            <div className="form-group col-md-4 col-half-offset">
              <label htmlFor="study" className="fw500">
                Final Options List
              </label>
            </div>
            <div className="form-group col-md-6 col-half-offset">
              <div className="border p-2" ref="finalOptContainer" id="finalOptContainer" title="Drag & Drop to reorder">
                {this.state.finalOptions &&
                  orderBy(this.state.finalOptions, 'sequence', 'asc').map((item, index) => {
                    return (
                      <div
                        className="border mb-1 p-1 dragOptions"
                        draggable="true"
                        title={item.value}
                        onDragStart={e => this.onOptionsDragStart(e, index)}
                        onDragOver={e => this.onOptionsDragOver(e, index)}
                        onDrop={e => {
                          this.onOptionsDrop(e, index);
                        }}
                        onDragEnter={e => {
                          this.onOptionsDragEnter(e, index);
                        }}
                        onDragLeave={e => {
                          this.onOptionsDragLeave(e, index);
                        }}
                        key={index}
                      >
                        {item.value}
                        <i
                          className="material-icons drag-clear"
                          title="Remove options"
                          onClick={e => this.removeFinalOptions(e, index)}
                        >
                          clear
                        </i>
                      </div>
                    );
                  })}
                {this.state.finalOptions.length < 1 && <div className="emptyOptions">Please add options</div>}
              </div>
            </div>
          </div>
          <hr className="hrdivider m-0" />
        </ModalBoxes.Body>
        <ModalBoxes.Footer>
          <ButtonGroup>
            <Button priority="medium" onClick={this.onClose}>
              Cancel
            </Button>
            <Button onClick={() => this.addItem()}>Save</Button>
          </ButtonGroup>
        </ModalBoxes.Footer>
      </>
    );
  }
}

EditFormAnswerFields.className = 'element-setup-modals';
EditFormAnswerFields.size = 'w650';

export default EditFormAnswerFields;
